import * as C from '../common/constants';
import * as ROUTES from '../common/routes';
import CircularProgress from '@mui/material/CircularProgress';
import Marker from './Marker';
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { GoogleMap, useLoadScript } from '@react-google-maps/api';
import { fetchData } from '../common/app/actions';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

const useStyles = makeStyles(
  (): StyleRules =>
    createStyles({
      containerStyle: {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
      },
      wrapperStyle: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        maxHeight: `${C.MAX_WIDTH}px`,
      },
      centerContainerStyle: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '30vh',
        flex: 1,
      },
    })
);

const containerStyle = {
  width: '100%',
  height: `${C.MAX_WIDTH}px`,
};

const mapCenter = {
  lat: 56.4714549,
  lng: 24.5591238,
};

const MapContainer = (): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search, pathname } = useLocation();
  const lng = useSelector((state: any) => state.app.lng);
  const allAnswersData = useSelector((state: any) => state.app.allAnswersData);

  const [markersData, setMarkersData] = useState(null);

  const { isLoaded, loadError } = useLoadScript({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyDvC3FcVPOX5tI_PBgDHE9QEQx4bdM4up8', //'AIzaSyBB7Yz0OeaB9ELFkZ_kVpxMkxjeCEHVNN8',
    language: 'lv',
    region: 'lv',
  });

  useEffect(() => {
    dispatch(fetchData(C.ALL_ANSWERS_DATA, { allAnswers: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (allAnswersData && !markersData) {
      const markersStorage = [];

      const themesData = allAnswersData?.pages;
      themesData.forEach((theme) => {
        const subThemesData = theme.pages;
        subThemesData.forEach((subTheme) => {
          const surveys = subTheme.pages;
          if (surveys?.length) {
            const surveysWithMarkers = surveys.filter(
              (survey) => survey.content.location
            );
            markersStorage.push(...surveysWithMarkers);
          }
        });
      });

      setMarkersData(markersStorage);
    }
  }, [allAnswersData]); // eslint-disable-line react-hooks/exhaustive-deps

  const options = {
    streetViewControl: false,
    zoom: 7.8,
    zoomControlOptions: {
      position: (window as any).google?.maps.ControlPosition.LEFT_BOTTOM, // 'right-center' ,
      style: (window as any).google?.maps.ZoomControlStyle.SMALL,
    },
    mapTypeId: 'roadmap', // maps.MapTypeId.HYBRID, // ROADMAP / SATELLITE / HYBRID / TERRAIN
    // heading: 207,
    // mapId: 'f494e4a36e8f86da',
    // styles,
  };

  if (!markersData) {
    return (
      <div className={classes.centerContainerStyle}>
        <CircularProgress />
      </div>
    );
  }

  if (!isLoaded) {
    return null;
  }

  const onMarkerClick = (event, markerData) => {
    const uri = markerData.content.uri;
    const url = uri.replace('anketas/apstiprinatas/', 'theme/');

    navigate({
      pathname: `/${url}`,
      search,
    });
  };

  return (
    <div className={classes.containerStyle}>
      <div className={clsx(classes.wrapperStyle)}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={mapCenter}
          // zoom={10}
          // onLoad={onLoad}
          options={options}
          // onUnmount={onUnmount}
        >
          {markersData.map((marker, index) => {
            return (
              <Marker key={index} marker={marker} onClick={onMarkerClick} />
            );
          })}
        </GoogleMap>
      </div>
    </div>
  );
};

export default React.memo(MapContainer);
